export default {
    all: { method: 'GET', url: 'tipo-recebimento/all' },
    active: { method: 'GET', url: 'tipo-recebimento/active' },
    get: { method: 'GET', url: 'tipo-recebimento/get{/id}' },
    create: { method: 'POST', url: 'tipo-recebimento' },
    update: { method: 'PUT', url: 'tipo-recebimento' },
    inactive: { method: 'DELETE', url: 'tipo-recebimento/{/id}' },
};